
(function () {
  'use strict';

  var CART_OPEN_CLASS = 'adorables-cart-open';
  var CHECKOUT_RETURN_KEY = 'adorablesCheckoutReturnPending';
  var CHECKOUT_RETURN_DONE_KEY = 'adorablesCheckoutReturnDoneAt';

  function cartIsOpen() {
    var cart = document.getElementById('bls-header_minicart');
    return !!(cart && cart.classList.contains('bls__opend-popup-header'));
  }

  function syncCartOpenState() {
    var open = cartIsOpen();
    document.body.classList.toggle(CART_OPEN_CLASS, open);
    var form = document.getElementById('form-mini-cart');
    if (form) form.setAttribute('aria-hidden', open ? 'false' : 'true');
  }

  function collapseFbt(root) {
    if (!root) return;
    root.classList.add('cart-fbt--collapsed');
    root.classList.remove('cart-fbt--expanded');
    root.setAttribute('aria-expanded', 'false');
    var toggle = root.querySelector('[data-fbt-toggle], .cart-fbt__header');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function syncFbtAria(root) {
    if (!root) return;
    var expanded = !root.classList.contains('cart-fbt--collapsed');
    root.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    var toggle = root.querySelector('[data-fbt-toggle], .cart-fbt__header');
    if (toggle) toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function collapseFreshFbts(scope) {
    (scope || document).querySelectorAll('#form-mini-cart [data-fbt-root], #form-mini-cart .cart-fbt').forEach(function (root) {
      if (root.dataset.adorablesFbtTouched === 'true') return;
      collapseFbt(root);
      syncFbtAria(root);
    });
  }

  function markCheckoutNavigation() {
    try {
      sessionStorage.setItem(CHECKOUT_RETURN_KEY, String(Date.now()));
    } catch (error) {}
  }

  function shouldResyncAfterCheckout() {
    try {
      if (sessionStorage.getItem(CHECKOUT_RETURN_KEY) !== '1' && !sessionStorage.getItem(CHECKOUT_RETURN_KEY)) return false;
      if (/\/checkouts?\b|\/checkout\b/.test(window.location.pathname)) return false;
      var doneAt = Number(sessionStorage.getItem(CHECKOUT_RETURN_DONE_KEY) || 0);
      if (doneAt && Date.now() - doneAt < 10000) return false;
      return true;
    } catch (error) {
      return false;
    }
  }

  function resyncAfterCheckoutReturn() {
    if (!shouldResyncAfterCheckout()) return;
    try {
      sessionStorage.removeItem(CHECKOUT_RETURN_KEY);
      sessionStorage.setItem(CHECKOUT_RETURN_DONE_KEY, String(Date.now()));
    } catch (error) {}
    window.setTimeout(function () {
      window.location.reload();
    }, 80);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('#form-mini-cart [name="checkout"], #form-mini-cart .bls-btn-checkout, #form-mini-cart a[href*="/checkout"], #form-mini-cart a[href*="/checkouts"]')) {
      markCheckoutNavigation();
    }

    var toggle = event.target.closest && event.target.closest('#form-mini-cart [data-fbt-toggle], #form-mini-cart .cart-fbt__header');
    if (!toggle) return;
    var root = toggle.closest('[data-fbt-root], .cart-fbt');
    if (root) {
      root.dataset.adorablesFbtTouched = 'true';
      window.setTimeout(function () { syncFbtAria(root); }, 0);
    }
  }, true);

  function init() {
    syncCartOpenState();
    collapseFreshFbts(document);

    var cart = document.getElementById('bls-header_minicart');
    if (cart && cart.dataset.adorablesCroObserved !== 'true') {
      cart.dataset.adorablesCroObserved = 'true';
      new MutationObserver(function () {
        syncCartOpenState();
        window.setTimeout(function () {
          collapseFreshFbts(document);
        }, 0);
      }).observe(cart, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(function () {
      collapseFreshFbts(document);
      syncCartOpenState();
    }, 0);
  });
  document.addEventListener('submit', function (event) {
    if (event.target && event.target.closest && event.target.closest('#form-mini-cart')) {
      var submitter = event.submitter;
      if (!submitter || submitter.name === 'checkout' || submitter.classList.contains('bls-btn-checkout')) {
        markCheckoutNavigation();
      }
    }
  }, true);

  window.addEventListener('pageshow', function () {
    window.setTimeout(init, 0);
    window.setTimeout(resyncAfterCheckoutReturn, 30);
  });

  window.setTimeout(resyncAfterCheckoutReturn, 250);
})();
